<template>

  <div class="col-lg-5 col-md-8 mx-auto">
 
    <h6 v-if="tabName == 'menu'">{{ $t("text.menu") }}</h6>
    <h6 v-if="tabName == 'fav'">{{ $t("text.favourite") }}</h6>
    <h6 v-if="tabName == 'deals'">{{ $t("text.deals") }} ({{availableCoupons.length}})</h6>
    <menu-tree
      v-if="tabName == 'menu'"
      :depth="0"
      :categories="categories"
      :specials="specials"
      :msgEmpty="$t('empty.categories')"
      image="no-menu"
    ></menu-tree>
    <menu-tree
      v-if="tabName == 'fav'"
      :depth="0"
      :categories="favorites"
      :msgEmpty="$t('empty.favourites')"
      icon="k-icon-tab-favourites"
    ></menu-tree>
    <deals v-show="tabName == 'deals'" :coupons="availableCoupons"  ></deals>
    
  </div>
</template>
<script>
import MenuTree from "./MenuTree";
import Deals from "./Deals"
export default {
  name: "menu-section",
  components: {
    MenuTree,
    Deals
  },
  props: {
    categories: Array,
    tabName: String,
    favorites:Array,
    specials:Array,
  },
  computed : {
    availableCoupons() {
      if (
        !this.selectedLocation ||
        !this.selectedLocation.coupons ||
        !this.selectedLocation.coupons.length
      )
        return [];
      return this.selectedLocation.coupons.filter((c) => !c.auto_applied);
    },
  },
};
</script>
